// src/data.js
// Shared organization information and program data

export const ORG = {
  name: "POWER PLAN DEVELOLMENT PROGRAM ፓወር ፕላን የልማት ፕሮግራም",
  regNo: "3662/2019",
  tin: "0052082632",
  headquarters: "Addis Ababa, Ethiopia",
  emails: ["power@powerplandevelopmentprogram.org", "milkway2020@gmail.com"],
  phones: ["+251 911 047 471", "+251 963 140 757", "+251 911 978 819"],
  tagline:
    "Community-driven, inclusive development for women, youth and marginalized groups."
};

export const PROGRAMS = [
  {
    title: "Youth Development & Empowerment",
    summary: "Creating opportunities for young people through skill-building, entrepreneurship, and leadership programs.",
    details: "PPDP works to empower youth by enhancing their employability and engagement in community development. The program includes vocational training, mentorship, and entrepreneurship incubation centers to promote self-reliance."
  },
  {
    title: "Gender Equality & Women's Economic Empowerment",
    summary: "Enhancing women’s economic participation and leadership in community decision-making.",
    details: "This program promotes women’s access to resources, education, and business development. PPDP provides microfinance support, cooperative training, and advocacy for gender-sensitive policies."
  },
  {
    title: "SRHR (Sexual & Reproductive Health & Rights)",
    summary: "Supporting communities to access quality SRHR education and services.",
    details: "PPDP collaborates with health offices and schools to ensure youth and women have access to information and services related to reproductive health, family planning, and gender-based violence prevention."
  },
  {
    title: "Education Access & Literacy",
    summary: "Promoting inclusive education for marginalized groups.",
    details: "The program improves access to quality education for children and adults through literacy campaigns, school material support, and inclusive education advocacy."
  },
  {
    title: "WASH (Water, Sanitation & Hygiene)",
    summary: "Improving access to clean water and promoting hygiene practices.",
    details: "PPDP implements sustainable WASH initiatives such as borehole construction, school sanitation programs, and community hygiene awareness campaigns."
  },
  {
    title: "Environmental Protection & Climate Resilience",
    summary: "Promoting eco-friendly practices and sustainable livelihoods.",
    details: "Activities include tree planting, community reforestation, climate adaptation training, and sustainable agriculture practices to reduce vulnerability to climate shocks."
  },
  {
    title: "Livelihoods & Skills Development",
    summary: "Supporting income-generating activities and skills training.",
    details: "PPDP empowers disadvantaged youth and women through hands-on vocational and digital skills development, helping them secure employment or start small businesses."
  },
  {
    title: "Peacebuilding & Conflict Prevention",
    summary: "Building social cohesion and promoting peace among communities.",
    details: "This program facilitates dialogue platforms, community-based peace committees, and youth leadership initiatives to foster tolerance, unity, and conflict resolution."
  }
];


export const TEAM = [
  { name: "Berihun Eyasu Reta", role: "Co-Director General" },
  { name: "Etsegenet Mulugeta", role: "Co-Director of Programs" },
  { name: "Abraham Tsegaye", role: "Director, Grants & Finance" }
];
